import Component from "vue-class-component";
import { FeatureFlagDto } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagDto";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import sortHelper from "../../Helper/sortHelper";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { FeatureFlagManagerInstance, IFeatureFlagMapped } from "../Controls/FeatureFlagManager";
import { VueBase } from "../Controls/VueBase";

@Component
export default class ListeFeatureFlagComponent extends VueBase {
    public dataIsReady = false;
    public listeFeatureFlag: IFeatureFlagMapped[] = [];
    public initialListeFeatureFlag: boolean[] = [];
    public changedListeFeatureFlag: boolean[] = [];
    public filtreRecherche = "";
    public sortOrder = true;
    public typeSort = "title";

    public mounted(): void {
        this.dataIsReady = false;

        // Abonnement à l'événement indiquant que les feature flags sont chargés
        EventBus.$on(EventConstants.FEATURE_FLAG_LOADED, () => {
            this.setListeFeatureFlag();
        });

        // Si la liste est déjà disponible, on l'utilise directement
        if (FeatureFlagManagerInstance.listeFeatureFlag != null) {
            this.setListeFeatureFlag();
        }
    }

    /**
     * Défini listeFeatureFlag et map
     */
    public setListeFeatureFlag(): void {
        this.synchronizeBooleanFlagStates();
        this.listeFeatureFlag = this.mapListeFeatureFlag(FeatureFlagManagerInstance.listeFeatureFlag);
        this.dataIsReady = true;
    }

    /**
     * Synchronise les tableaux des états initiaux et modifiés des feature flags
     */
    public synchronizeBooleanFlagStates(): void {
        this.initialListeFeatureFlag = FeatureFlagManagerInstance.listeFeatureFlag.map((flag) => flag.EstActive);
        this.changedListeFeatureFlag = FeatureFlagManagerInstance.listeFeatureFlag.map((flag) => flag.EstActive);
    }

    /**
     * Change la colonne de tri et inverse l'ordre de tri.
     * @param type Nom de la colonne à trier
     */
    public sortColumn(type: string): void {
        this.sortOrder = !this.sortOrder; // Inverse l'ordre de tri
        this.typeSort = type;
    }

    /**
     * Met à jour la liste des feature flags via le manager et recharge la page.
     * Le rechargement de la page permet de mettre à jour les feature flags dans le context pour éviter tout problème.
     */
    public async updateFeatureFlag(): Promise<void> {
        const result = await FeatureFlagManagerInstance.updateFeatureFlag(this.listeFeatureFlag);

        if (result) {
            window.location.reload();
        }
    }

    /**
     * COMPUTED
     * Retourne la liste filtrée et triée des feature flags selon la recherche et le tri sélectionné.
     */
    public get listeFeatureFlagComputed(): IFeatureFlagMapped[] {
        const filtre = this.filtreRecherche.toLowerCase();
        const filteredList = this.listeFeatureFlag.filter((flag) => flag.title.toLowerCase().includes(filtre));

        return sortHelper.sortAccentInsensitive(filteredList, this.typeSort, this.sortOrder);
    }

    /**
     * Vérifie si les deux tableaux de booléens (états initiaux et modifiés des feature flags) sont identiques.
     * Retourne true si les deux tableaux ont la même longueur et que chaque élément à la même position est égal.
     * @returns true si les deux tableaux sont strictement identiques, false sinon.
     */
    public areBooleanArraysEqual(): boolean {
        return this.initialListeFeatureFlag.length === this.changedListeFeatureFlag.length && this.initialListeFeatureFlag.every((val, idx) => val === this.changedListeFeatureFlag[idx]);
    }

    /**
     * Met à jour l'état d'un feature flag dans le tableau des changements
     * @param flagId L'ID du feature flag à modifier
     * @param newValue La nouvelle valeur
     */
    public updateFeatureFlagState(flagId: number, newValue: boolean): void {
        const realIndex = this.listeFeatureFlag.findIndex(f => f.id === flagId);
        if (realIndex !== -1) {
            this.changedListeFeatureFlag[realIndex] = newValue;
        }
    }

    /**
     * Transforme la liste des FeatureFlagDto en IFeatureFlagMapped pour l'affichage.
     * @param listeFeatureFlag Liste d'origine
     */
    private mapListeFeatureFlag(listeFeatureFlag: FeatureFlagDto[]): IFeatureFlagMapped[] {
        return listeFeatureFlag.map((flag) => ({
            id: flag.Id,
            isActive: flag.EstActive,
            title: this.setTitleFeatureFlag(flag.Module)
        }));
    }

    /**
     * Retourne le libellé à afficher pour chaque module de feature flag.
     * @param module Module du feature flag
     */
    private setTitleFeatureFlag(module: FeatureFlagModuleEnum): string {
        switch (module) {
            case FeatureFlagModuleEnum.BulletinClarifie:
                return "Bulletin Clarifié";
            case FeatureFlagModuleEnum.TransfertSql:
                return "Liste de transfert SQL";
            case FeatureFlagModuleEnum.EnqueteSatisfactionPst:
                return "Enquête de satisfaction PST";
            case FeatureFlagModuleEnum.ModuleCongeV3:
                return "Module des congés V3";
            case FeatureFlagModuleEnum.ModuleCongeV4:
                return "Module des congés V4";
			case FeatureFlagModuleEnum.AncienneEnqueteSatisfactionPst:
				return "Ancienne enquête de satisfaction PST";
            case FeatureFlagModuleEnum.Jimo:
                return "Jimo";
            case FeatureFlagModuleEnum.AttestationCrpcenTpt:
                return "Attestation CRPCEN TPT";
            default:
                return "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/listeFeatureFlag/listeFeatureFlag.ts